export enum RecordSourceEnum {
    Salesbuzz = 0,
    Infinity_ERP = 1,
    MS_Dynamics_AX = 2,
    Oracle_EBS = 3,
    IBM_AS_400 = 4,
    MS_GP = 5,
    SAP = 6,
    ISCALA = 7,
    // RoadNet = 8, we take * for SAP B1
    Mandoobi = 14,
    MandoobiTemp = 15,
    OracleFusion = 20,
    SAPB1 = 8,
    Infor = 9,
    BASIS = 10
}
